module.exports = __webpack_public_path__ + "static/img/pitch_blue_wide.4dddeec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_blue_wide.png
// module id = C2pq
// module chunks = 94